import React from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { AlertItemSC, AlertBadgeSC } from './alert-item.styled';
import { getDateFormat } from '../../../../helpers/utils-helpers';

type TProps = {
  method: 'HILBI' | 'SMS' | 'EMAIL';
  text?: string;
  createdAt?: string;
  subject?: string;
  title?: string;
  isSent?: boolean;
  sentCount?: number;
  deliveredCount?: number;
  recipientsCount?: number;
};
const AlertItem: React.FC<TProps> = ({
  method,
  text,
  subject,
  createdAt,
  isSent,
  sentCount,
  deliveredCount,
  title,
  recipientsCount,
}) => {
  const date = createdAt ? moment(createdAt) : moment();
  return (
    <AlertItemSC>
      <div>
        <AlertBadgeSC method={method}>
          <FormattedMessage id="alerts.sent_using_n" values={{ n: method.toLowerCase() }} />
        </AlertBadgeSC>
      </div>
      <time>
        <FormattedMessage id="alerts.created_at_n" values={{ n: date.format(getDateFormat()) }} />
      </time>
      {isSent && method !== 'HILBI' ? (
        <span className="ai-sent">
          (<FormattedMessage id="alerts.sent_n" values={{ n: `${sentCount || 0}` }} />)
        </span>
      ) : isSent && method === 'HILBI' ? (
        <span className="ai-sent">
          (<FormattedMessage id="alerts.sent_n" values={{ n: `${recipientsCount || 0}` }} />)
        </span>
      ) : null}

      {subject ? <h5>{subject}</h5> : null}
      {title ? <h5>{title}</h5> : null}

      <div>{text}</div>
    </AlertItemSC>
  );
};

AlertItem.defaultProps = {
  isSent: true,
};

export default AlertItem;
